export default function ChevronLeft({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.44545 6.96859L8.70693 1.70711L7.29272 0.292892L0.554199 7.03141L7.3241 13.2372L8.67555 11.7628L3.44545 6.96859Z"
        fill="currentColor"
      />
    </svg>
  )
}
